<template>
  <div>
    <div class="breadcrumb">
      <ul>
        <li><router-link to="/">Dashboard</router-link></li>
        <li>New role</li>
      </ul>
    </div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title mb-3">New role</div>
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold"> New roles</small>
              </legend>
              <div>
                <form @submit.prevent="newRole()">
                  <div class="form-group">
                    <label>role name</label>
                    <input
                      type="text"
                      class="form-control rolename"
                      placeholder="rolename"
                      required
                    />
                  </div>
                  <div class="form-group">
                    <label>slug</label>
                    <input
                      type="text"
                      class="form-control roleSlug"
                      placeholder="slug"
                      required
                    />
                  </div>
                  <button
                    type="submit"
                    class="btn btn-primary btn-flat creatingRole"
                  >
                    <i class="fa fa-plus"></i> create role
                  </button>
                  <button
                    type="button"
                    class="btn btn-info btn-flat creatingRoleLoader"
                  >
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <i
                      class="fa fa-spinner fa-spin"
                      style="font-size: 24px"
                    ></i>
                    please wait...
                  </button>
                </form>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions(["newRole"]),
  },
};
</script>
<style scoped>
.creatingRoleLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/roles/role.vue